import * as React from "react";
import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";
import { Box, InputLabel, Paper, Typography, useTheme } from "@mui/material";
import { makeStyles } from "tss-react/mui";

const useStyles = makeStyles()((theme) => {
    return {
        select: {
            "& .MuiSelect-select ": {
                padding: "14px !important"
            },
            "&:before": {
                borderColor: "white",
            },
            "&:after": {
                borderColor: "white",
            },
            "&:not(.Mui-disabled):hover::before": {
                borderColor: "white",
            },
            "& .MuiInputBase-input": {
                height: "15px",
                fontSize: '14px',
            },
            "& .MuiInputBase-fullWidth": {
                fontSize: "14px",
                fontFamily: "Poppins",
            },
            "& .MuiOutlinedInput-notchedOutline": {
                borderColor: "#EEEEEE",
                borderRadius: "10px",
            },
            "& .MuiOutlinedInput-root": {
                "& fieldset": {
                    borderColor: "#EEEEEE",
                    borderRadius: "10px",
                },
                "&:hover fieldset": {
                    borderColor: "#EEEEEE",
                },
                "&.Mui-focused fieldset": {
                    borderColor: "#EEEEEE",
                },
            },
            "&:hover": {
                "& .MuiOutlinedInput-notchedOutline": {
                    border: "1px solid #EEEEEE"
                },
            },
            "&.Mui-focused": {
                "& .MuiOutlinedInput-notchedOutline": {
                    border: "1px solid #EEEEEE"
                },
            },
        },
        icon: {
            fill: '#eee',
        },
        root: {
            // color: 'white',
        },
        main: {
            background: theme?.palette?.bgWhite?.main,
            borderRadius: '12px',
            minWidth: "50px",
            ".MuiInputBase-input": {
                height: "10px",
                fontSize: '14px',
            },
            ".MuiInputBase-formControl:hover .MuiOutlinedInput-notchedOutline": {
                borderColor: `${theme?.palette?.primary?.main} !important`,
            },
            ".MuiInputBase-formControl.Mui-disabled:hover .MuiOutlinedInput-notchedOutline": {
                borderColor: `${theme?.palette?.bgLightBlack?.main} !important`,
            },
            ".MuiOutlinedInput-notchedOutline": {
                borderColor: `${theme?.palette?.backgroundDefaultColor?.main} !important`,
                borderRadius: '8px',
            },
            ".Mui-focused .MuiOutlinedInput-notchedOutline": {
                borderColor: `${theme?.palette?.primary?.main} !important`,
                borderWidth: "1px !important",
            },
            "& .MuiInputBase-formControl.Mui-disabled": {
                backgroundColor: "#e0e0e0",
                borderRadius: '8px',
                opacity: 0.8
            }
        },
        error: {
            border: "1px solid green",
        },
    };
});

export default function AutoCompleteSearch({
    width,
    height,
    text,
    valid,
    options,
    placeholder,
    handleChange,
    name,
    handleChangeInput,
    fontWeight,
    labelSize,
    disabled = false,
    defaultValue,
    freeSolo = true,
    clearOnSelect,
    blurOnSelect,
    loadData,
    onBlur,
    searchValue,
    handleSearch,
    multiple = false,
    fullWidth,
    className
}) {
    const { classes, cx } = useStyles();
    const theme = useTheme()

    const autocompleteListStyles = {
        paper: {
            background: theme?.palette?.background?.paper, // Set your desired background color
            boxShadow: theme?.shadows[1], // Add shadow if needed
            borderRadius: theme?.shape?.borderRadius, // Add border radius
        },
    };
    return (
        <>
            {text && (
                <Box
                    mt={0.5}
                    // mb={1}
                    display="flex"
                    fontSize="12px"
                    flexDirection={"row"}
                >
                    <InputLabel
                        sx={{
                            marginRight: "3px",
                            fontWeight: fontWeight,
                            fontSize: "14px",
                            color: theme.palette.bgDarkPrimary.main,
                            padding: '3px',
                        }}
                    >
                        {text}
                    </InputLabel>
                    {valid && (
                        <Typography color="#EF627A" component={"caption"} variant={"body2"}>
                            *
                        </Typography>
                    )}
                </Box>
            )}
            <Box display="flex">
                <Autocomplete
                    fullWidth={fullWidth}
                    multiple={multiple}
                    className={cx(classes.main, className)}
                    disabled={disabled}
                    // autoHighlight={false}
                    // disablePortal
                    blurOnSelect={blurOnSelect}
                    options={options || []}
                    onChange={handleChange}
                    isOptionEqualToValue={(option, value) => {
                        if (value === "" || value === option) {
                            return true;
                        } else {
                            return false;
                        }
                    }}
                    value={defaultValue || ""}
                    defaultValue={defaultValue || ""}
                    sx={{ width: width, backgroundColor: "white", }}
                    freeSolo={freeSolo}
                    renderInput={(params) => (
                        <TextField
                            className="searchInput"
                            {...params}
                            onBlur={onBlur}
                            placeholder={placeholder}
                            onChange={handleSearch}
                            name={name}
                            disabled={disabled ? disabled : false}
                            value={searchValue}
                        />
                    )}
                // PaperComponent={}
                // PaperComponent={({ children }) => (
                //     <Box {...children.props} style={autocompleteListStyles.paper} />
                // )}
                />
            </Box>
        </>
    );
}
